import React from 'react'
import PropTypes from 'prop-types'
import { IconPurpose } from 'secondstep-components'

import {
  CalloutBoxContainer,
  IconContainer,
  TextContent,
  Title,
  Description,
} from './component.styles'

const CalloutBox = ({
  title = 'Program Purpose',
  description = 'Missing purpose description',
  color = '#3C6E90',
  dataTestId = 'callout-box',
}) => {
  return (
    <CalloutBoxContainer data-testid={dataTestId}>
      <IconContainer>
        <IconPurpose color={color} />
      </IconContainer>
      <TextContent>
        <Title color={color} data-testid={`${dataTestId}-title`}>
          {title}
        </Title>
        <Description data-testid={`${dataTestId}-description`}>
          {description}
        </Description>
      </TextContent>
    </CalloutBoxContainer>
  )
}

CalloutBox.propTypes = {
  color: PropTypes.string,
  dataTestId: PropTypes.string,
  description: PropTypes.string,
  iconFillColor: PropTypes.string,
  title: PropTypes.string,
}

export default CalloutBox
